import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, IconButton } from "@mui/material";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { DRAWER_TYPES } from "../../Constantes/drawers";
import { CloseIcon } from "../../Components/Icons/Miscellaneous/CloseIcon";
import { useMobile } from "../../Hooks/useMobile";
import { useDesktop } from "../../Hooks/useDesktop";
import { RegisterForm } from "../../Forms/RegisterForm/RegisterForm";
import { Progress } from "../../Components/Progress/Progress";
import logoIcon from "../../Recursos/genesis_logo_icon.webp";
import logoFull from "../../Recursos/genesis_logo_full.webp";
import character1TextBottom from "../../Recursos/character_1_text-bottom.webp";
import character1TextInline from "../../Recursos/character_1_text-inline.webp";
import { useNavigate } from "react-router-dom";
import { RUTAS } from "rutas";
import { paramService } from "Services/param_service";
import { useQuery } from "Hooks/useQuery";
import "./RegisterDrawer.scss";

export const RegisterDrawer = () => {
  const { data: images } = useQuery(paramService.param, {
    grupo: "imagenes",
    files: true,
  });

  const getUrlValue = (codigo) => {
    return (
      images?.data?.find((item) => item.codigoParametro === codigo)?.url || "#"
    );
  };

  const logoTabletUp = getUrlValue("logo_genesis") || logoFull;
  const logoMobile = getUrlValue("logo_mobile") || logoIcon;

  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const isOpen = activeDrawer === DRAWER_TYPES.REGISTER;

  const isMobile = useMobile();
  const isDesktop = useDesktop();
  const logoSrc = isMobile ? logoMobile : logoTabletUp;
  const characterSrc = !isDesktop ? character1TextBottom : character1TextInline;

  const handleClose = () => {
    dispatch(setActiveDrawer(null));
  };

  const handleClickLogin = () => {
    dispatch(setActiveDrawer(DRAWER_TYPES.LOGIN));
  };

  const handleLogoClick = () => {
    navigate(RUTAS.PRINCIPAL);
    dispatch(setActiveDrawer(null));
  };

  useEffect(() => {
    if (!isOpen) {
      setCurrentStep(1);
    }
  }, [isOpen]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      className="register-drawer"
      PaperProps={{
        className: "register-drawer__paper",
      }}
    >
      <div className="register-drawer__container">
        <div className="register-drawer__header">
          <div className="register-drawer__logo" onClick={handleLogoClick}>
            <img
              src={logoSrc}
              alt="Genesis Logo"
              onError={(e) => {
                // Fallback adicional en caso de que falle la carga
                e.target.src = isMobile ? logoIcon : logoFull;
              }}
            />
          </div>
          <IconButton onClick={handleClose} aria-label="Cerrar">
            <CloseIcon width={32} height={30} className="text-azul-7" />
          </IconButton>
        </div>
        <div className="register-drawer__cintillo" />
        <div className="register-drawer__body">
          <div className="register-drawer__content">
            <h2 className="register-drawer__title-mobile heading-l-bold mb-0">
              Crea tu cuenta
            </h2>

            <div className="register-drawer__image">
              <img
                src={characterSrc}
                alt="Genesis Character"
                className="register-drawer__character"
              />
            </div>

            <div className="register-drawer__form-section">
              <h2 className="register-drawer__title-tablet-desktop">
                Crea tu cuenta
              </h2>
              <p className="register-drawer__subtitle">
                Escribe la información que se te solicita
              </p>

              <Progress current={currentStep} total={2} textAlign="left" />

              <RegisterForm
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                isMobile={isMobile}
              />

              {currentStep === 1 && (
                <>
                  <div className="register-drawer__separator">
                    <div className="register-drawer__separator-line"></div>
                    <span className="register-drawer__separator-text">o</span>
                    <div className="register-drawer__separator-line"></div>
                  </div>

                  <span className="register-drawer__login-link">
                    <p className="paragraph-m-medium">¿Ya tienes una cuenta?</p>
                    <p
                      className="paragraph-m-bold text-cian"
                      onClick={handleClickLogin}
                    >
                      Inicia sesión
                    </p>
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
